import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=24f295e1&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SubmitButton.vue?vue&type=style&index=1&id=24f295e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f295e1",
  null
  
)

export default component.exports